module.exports = __webpack_public_path__ + "img/vip.084024c2.svg";